import React from "react"
import classes from "./Info.module.css"

const info = props => {
    return (
        <>
            <div className={classes.Wrapper}>
                <p>
                    This webpage was created by Lean. If you have any questions, bugreports,feedback, suggestions, or
                    similar, feel free to contact me. You can find me on{" "}
                    <a href="https://twitter.com/LeanYoshi">Twitter</a> or Discord (Lean#3146).
                </p>
                <p>
                    If you like my work, feel free to help me out by donating via{" "}
                    <a href="https://paypal.me/cflean">PayPal</a>
                </p>
            </div>
        </>
    )
}

export default info
